import "core-js/modules/es.array.push.js";
import { showToast } from 'vant';
import 'vant/es/toast/style';
import PhoneInput from "@/components/phoneInput.vue";
export default {
  data() {
    return {
      tel: '',
      buttonL: false,
      show: false
    };
  },
  components: {
    PhoneInput
  },
  methods: {
    opepApp() {
      this.OPENAPP();
    },
    onClickCart() {
      this.$router.push('cart');
    },
    nextCheck() {
      this.$refs.phoneInput.handleValidate();
    },
    nextClick(validate) {
      if (validate) {
        try {
          this.buttonL = true;
          this.$http.post(this.$apis.checkExists + "?mobile=" + this.tel, {}).then(result => {
            if (result.data.code == 0) {
              if (result.data.data == 0) {
                this.$router.push({
                  name: 'register',
                  params: {
                    tel: this.tel
                  }
                });
              }
              if (result.data.data == 1) {
                this.$router.push({
                  name: 'msg',
                  params: {
                    tel: this.tel
                  }
                });
              }
              if (result.data.data == 2) {
                this.show = true;
              }
              this.buttonL = false;
            } else {
              showToast(result.data.message);
            }
          });
        } catch (e) {
          console.log(e);
        }
      }
    }
  }
};